<template>
<div class="xin">
    <!-- tab 切换  -->
    <div class="switch">
        <el-tabs>
            <!-- APT开关 -->
            <el-tab-pane>
                <span slot="label"> {{ $t("logs.apt1") }}</span>
                <div class="lie">
                    <table>
                        <tbody>
                            <tr>
                                <!-- APT扫描最大尺寸 -->

                                <td>{{ $t("logs.apt3") }}:</td>
                                <td style="display:flex;flex-direction:row">
                                    <el-input v-model="apt_chk_max_size" placeholder=""></el-input>

                                    <el-alert :title="$t('logs.apt4')" type="warning" show-icon :closable="false">
                                    </el-alert>
                                </td>
                            </tr>

                            <tr>
                                <!-- 是否开启APT扫描 -->

                                <td>{{ $t("logs.apt5") }}:</td>
                                <td style="display:flex;flex-direction:row">
                                    <el-checkbox-group v-model="enable_apt_chk">
                                        <el-checkbox label=""></el-checkbox>
                                    </el-checkbox-group>
                                    <el-alert :title="$t('logs.apt6')" type="warning" show-icon :closable="false">
                                    </el-alert>
                                </td>
                            </tr>
                            <tr>
                                <td>{{ $t("logs.apt7") }}:</td>
                                <td style="display:flex;flex-direction:row">
                                    <el-checkbox-group v-model="apt_mode">
                                        <el-checkbox label=""></el-checkbox>
                                    </el-checkbox-group>
                                    <el-alert :title="$t('logs.apt8')" type="warning" show-icon :closable="false">
                                    </el-alert>
                                </td>
                            </tr>
                            <tr>
                                <td></td>
                                <td style="display:flex;flex-direction:row">
                                    <el-button type="primary" @click="save_greylist()" :disabled="$root.jurisdiction.only_query==0">{{
                      $t("logs.save_a")
                    }}</el-button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </el-tab-pane>
            <!-- 按帐号查询 -->
            <el-tab-pane>
                <span slot="label"> {{ $t("logs.apt2") }}</span>
                <div class="lie">
                    <table>
                        <tbody>
                            <tr>
                                <!-- 设备登录用户 -->

                                <td>{{ $t("logs.apt9") }}:</td>
                                <td>
                                    <el-input v-model="apt_dev_user" placeholder=""></el-input>
                                </td>
                            </tr>
                            <tr>
                                <!-- 登录用户密码 -->

                                <td>{{ $t("logs.apt10") }}:</td>
                                <td>
                                    <el-input v-model="apt_dev_pwd" placeholder="" show-password></el-input>
                                </td>
                            </tr>
                            <tr>
                                <!-- 设备ID号 -->
                                <td>{{ $t("logs.apt11") }}:</td>
                                <td>
                                    <el-input v-model="apt_dev_id" placeholder=""></el-input>
                                </td>
                            </tr>
                            <tr>
                                <!-- APT设备访问IP -->

                                <td>{{ $t("logs.apt12") }}:</td>
                                <td>
                                    <el-input v-model="apt_dev_ip" placeholder=""></el-input>
                                </td>
                            </tr>
                            <tr>
                                <!-- APT设备访问端口 -->

                                <td>{{ $t("logs.apt13") }}:</td>
                                <td>
                                    <el-input v-model="apt_dev_port" placeholder=""></el-input>
                                </td>
                            </tr>
                            <tr>
                                <td></td>
                                <td style="display:flex;flex-direction:row">
                                    <el-button type="primary" @click="save_greylist1()" :disabled="$root.jurisdiction.only_query==0">{{
                      $t("logs.save_a")
                    }}</el-button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</div>
</template>

<script>
// import $ from "jquery";
export default {
    data() {
        return {
            enable_apt_chk: '',
            apt_chk_max_size: '',
            apt_mode: '',
            apt_dev_user: '',
            apt_dev_pwd: '',
            apt_dev_id: '',
            apt_dev_ip: '',
            apt_dev_port: '',
            textarea: "",
            input: "",
            time: new Date(2020, 9, 10, 18, 40),
            value1: "",

            tableData: [{
                address: "44",
            }, ],
            emali: "",
            value: "",
            checkList: [],
            tanchu: false,
            options: [{
                    value: "选项1",
                    label: "不使用TLS",
                },
                {
                    value: "选项2",
                    label: "增加信头标记",
                },
                {
                    value: "选项3",
                    label: "强制TLS",
                },
            ],
            checked: "",
            fileList: [],
            radio: [],
            data_loadok1: '',
            data_loadok2: '',
        };
    },
    mounted() {
        this.getFileList1()
        this.getFileList2()
    },
    methods: {
        save_greylist1() {
this.$save_hint_test();
this.$disable_hint_test();
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            let str = this.$qs.stringify({
                __mode: "save_apt_dev_param",
                sid: sid,

                apt_dev_id: this.apt_dev_id,
                apt_dev_ip: this.apt_dev_ip,
                apt_dev_port: this.apt_dev_port,
                apt_dev_pwd: this.apt_dev_pwd,
                apt_dev_user: this.apt_dev_user,
                data_loadok: this.data_loadok2

            });
            this.$axios
                .post("/api/adm/cgi/aspam.cgi", str)
                .then((res) => {
                    console.log(res);
this.$close_hint_test();
this.$close_disable_hint_test();
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {

                        this.getFileList2()
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });
                    }
                })
        },
        save_greylist() {
            this.$save_hint_test();
            this.$disable_hint_test();
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            let str = this.$qs.stringify({
                __mode: "save_apt_param",
                sid: sid,
                enable_apt_chk: this.enable_apt_chk == true ? 1 : 0,
                apt_mode: this.apt_mode == true ? 1 : 0,
                apt_chk_max_size: this.apt_chk_max_size,
                data_loadok: this.data_loadok1

            });
            this.$axios
                .post("/api/adm/cgi/aspam.cgi", str)
                .then((res) => {
                    // console.log(res);
            this.$close_hint_test();
            this.$close_disable_hint_test();
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {

                        this.getFileList1()
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });
                    }
                })
        },
        // 过滤单元加载
        getFileList2() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/aspam.cgi", {
                    params: {
                        __mode: "load_apt_dev_param",
                        sid: sid,
                    },
                })
                .then((res) => {
                    // console.log(res);

                    if(!res){
             this.loading = false;
          }
         else if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.data_loadok2 = res.data.ret.ok

                        this.apt_dev_id = res.data.ret.result.apt_dev_id
                        this.apt_dev_ip = res.data.ret.result.apt_dev_ip
                        this.apt_dev_port = res.data.ret.result.apt_dev_port
                        this.apt_dev_pwd = res.data.ret.result.apt_dev_pwd
                        this.apt_dev_user = res.data.ret.result.apt_dev_user

                    }
                })
              
        },
        // 过滤单元加载
        getFileList1() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/aspam.cgi", {
                    params: {
                        __mode: "load_apt_param",
                        sid: sid,
                    },
                })
                .then((res) => {
                    console.log(res);

                    if(!res){
             this.loading = false;
          }
         else if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.data_loadok1 = res.data.ret.ok
                        this.enable_apt_chk = res.data.ret.result.apt_check == 1 ? true : false
                        this.apt_mode = res.data.ret.result.apt_mode == 1 ? true : false
                        this.apt_chk_max_size = res.data.ret.result.apt_max_msgsize

                    }
                })
              
        },
        // 显示
        tan: function () {
            this.tanchu = true;
        },
        // 打开关闭
        tanSend: function () {
            this.tanchu = false;
        },
        tanOff: function () {
            this.tanchu = false;
        },
    },
};
</script>

<style lang="less" scoped>
@import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/pou_up.less";

/deep/ .el-checkbox {
    margin-right: 8px;
}
</style>
